import { COUNTRY } from '../constants/types';

export const setCountry = (country) => ({
  type: COUNTRY,
  country: country
});